var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Converts a data URI to a file.
 *
 * @param dataUri The data URI scheme.
 * @param filename The name of the file.
 * @param lastModified The date of when the file was last modified.
 */
export function dataUriToFile(dataUri, filename, lastModified = new Date()) {
    return __awaiter(this, void 0, void 0, function* () {
        const blob = yield fetch(dataUri).then((response) => response.blob());
        return new File([blob], filename, {
            lastModified: lastModified.valueOf(),
            type: blob.type,
        });
    });
}
